import React, { useState } from "react";
import { TextField, Button, Typography } from "@material-ui/core";
import { useAuth } from "../../config/AuthContext";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  discussionBoard: {
    marginTop: theme.spacing(3),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },

  form: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "100%",
      color: theme.palette.text.secondary,
    },

    "& .MuiFormControl-root": {
      margin: theme.spacing(1),

      width: "100%",
      color: theme.palette.text.secondary,
    },

    "& .MuiButton-root": {
      margin: theme.spacing(1),
      padding: theme.spacing(1),
      width: "100%",
      background: theme.palette.primary.dark,
      color: theme.palette.primary.contrastText,
    },
  },
}));
const CommentForm = ({ blogKey }) => {
  const { dbRef, currentUser, signInWithGoogle } = useAuth();
  const [comment, setComment] = useState("");
  const [error, setError] = useState({
    commentError: false,
    commentErrorHelperText: "",
  });
  const classes = useStyles();

  const handleSignIn = async () => {
    await signInWithGoogle()
      .then(() => {
        console.log("user signed in");
      })
      .catch((err) => {
        console.log(
          `Error occured while trying to log you in : ${err.message}`
        );
      });
  };

  const validateForm = () => {
    if (!comment) {
      setError({
        commentError: true,
        commentErrorHelperText: "Comment cannot be empty!",
      });
      return false;
    }

    return true;
  };

  const handlePostComment = (e) => {
    e.preventDefault();
    const isValid = validateForm();

    if (isValid) {
      dbRef.child(`blogs/${blogKey}/BlogComments`).push({
        Comment: `${comment.slice(0, 1).toUpperCase()}${comment.slice(1)}`,
        Commenter: currentUser.displayName,
        CommentDate: new Date().toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        }),
      });

      setComment("");
      setError({
        commentError: false,
        commentErrorHelperText: "",
      });
    }
  };
  return (
    <>
      <Typography
        variant="h5"
        component="h5"
        className={classes.discussionBoard}
      >
        Discussion Board
      </Typography>

      <form className={classes.form}>
        <TextField
          autoFocus
          color="secondary"
          error={error.commentError}
          id="comment"
          label="Have a feedback? Comment here"
          helperText={error.commentErrorHelperText}
          variant="outlined"
          multiline
          rows={1}
          value={comment}
          onChange={(e) => setComment(e.target.value)}
        />
        {!currentUser && (
          <Button onClick={handleSignIn}>Sign In to post your comment</Button>
        )}
        {currentUser && (
          <Button
            variant="contained"
            type="submit"
            onClick={(e) => handlePostComment(e)}
          >
            Post Comment
          </Button>
        )}
      </form>
    </>
  );
};

export default CommentForm;
